const pathsInBucket = {
    images: {
        games: {
            dotaLogo: 'images/dota2logo.png',
            fortniteLogo: 'images/fortnite-logo.png'
        }
    }
}

export default pathsInBucket;